<style>
.color-box {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: sub;
    border: 1px solid #dcdee2;
}
</style>
<template>
    <div>
        <div>
            {{
                changeStatus == 1
                    ? "Availale reservation date：From 10 days in advance to today"
                    : "Availale reservation date：From 10 days to 1 day in advance"
            }}
        </div>
        <div class="margin-bottom-5 margin-top-10">
            <ButtonGroup>
                <Button
                    v-for="(item, index) in btnSearch"
                    :key="index"
                    :type="changeStatus === item.value ? 'primary' : 'default'"
                    @click="handleBtn(item.value)"
                >
                    {{ item.label }}
                </Button>
            </ButtonGroup>
            <!-- 色块 -->
            <span class="pull-right margin-top-5">
                <span class="color-box bg-primary"></span>Selected
                <span class="color-box"></span>Available Reservation
                <span class="color-box bg-warning"></span>Reservation Fully
                <span class="color-box bg-gray"></span>NO Reservation
            </span>
        </div>
        <!-- 自定义日历 -->
        <div>
            <v-calendar
                ref="reservatecalendar"
                :first-day-of-week="2"
                :attributes="attrs"
                @dayclick="chooseDay"
                is-expanded
                :disabled-dates="disRange"
                :timezone="'UTC'"
                locale="en"
                @transition-start="chooseOneDay"
            />
        </div>

        <div v-if="changeStatus == 1">
            <div class="font-bold margin-top-5 margin-bottom-5">
                <Icon type="ios-medical" class="color-error" />Please select
                delivery time {{ chooseTime }}
            </div>
            <div>
                Please select other available time，you can select other
                available date or express reservation if no available time
            </div>
        </div>
        <div v-else>
            <div class="text-right">
                Cost：<span class="color-error">100</span> USD
            </div>
            <div class="font-bold margin-top-5 margin-bottom-5">
                <Icon type="ios-medical" class="color-error" />First Choice of
                delivery time {{ chooseTime }}
            </div>
            <div
                class="font-bold margin-top-5 margin-bottom-5"
                style="padding-left: 12px"
            >
                Back up choice of delivery time {{ chooseTime1 }}
            </div>
            <div>
                Express Reservation instruction：
                <p>
                    1. Express reservation will be approved manully by warehouse
                    after you submited. Delivery can be arranged after the
                    reservation get approved.
                </p>
                <p>
                    2. The express reservation can be canceled without fees
                    before approved.
                </p>
            </div>
        </div>

        <div class="text-right">
            <Button type="primary" @click="submit">Submit</Button>
            <Button class="margin-left-5" @click="cancel">Cancel</Button>
        </div>
    </div>
</template>
<script>
import { HttpgetDateReserveQtyByClient } from "@/service/bespeak";
export default {
    props: ["bookingType", "orgWarehouseId", "type", "goodTypeCode"],
    data() {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        return {
            attrs: [],
            range: {},
            btnSearch: [
                { value: 1, label: "General" },
                { value: 0, label: "Express" },
            ],
            changeStatus: 1,
            disRange: [],
            chooseTime: "",
            chooseTime1: "",
            numFlag: 0,
            insufficAvaliabeRedDate: [],
            dayone: "",
        };
    },
    created() {
        let dayarr = this.getDay(0).split("-");
        this.dayone = dayarr[0] + "-" + dayarr[1] + "-01";

        if (this.bookingType == 0 && this.type != "add") {
            this.changeStatus = 0;
            this.btnSearch = [{ value: 0, label: "Express" }];
        }
        if (this.bookingType == 1 && this.type != "add") {
            this.changeStatus = 1;
            this.btnSearch = [{ value: 1, label: "General" }];
        }
        // 请求可预约的日期
        this.getAllDateDrawing();
        // 不可预约的范围
        // this.disRange = []
    },
    methods: {
        getAllDateDrawing() {
            HttpgetDateReserveQtyByClient({
                orgWarehouseId: this.orgWarehouseId,
                bookingType: this.changeStatus,
                currentDate: this.dayone,
                goodTypeCode: this.goodTypeCode,
            }).then(
                (res) => {
                    res.data.map((item) => {
                        if (item.status == 3) {
                            this.disRange.push(item.reserveDate);
                        }
                        if (item.status == 2) {
                            this.insufficAvaliabeRedDate.push(item.reserveDate);
                        }
                    });
                    if (this.insufficAvaliabeRedDate.length > 0) {
                        // 渲染可用不足红色日期
                        let insufficAvailability = {
                            highlight: "orange",
                            contentStyle: {
                                color: "white",
                            },
                            dates: this.insufficAvaliabeRedDate,
                        };
                        this.attrs.push(insufficAvailability);
                    }
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        chooseDay(val) {
            if (val.isDisabled) {
                return;
            }
            if (this.changeStatus == 0) {
                if (this.attrs.length > 1) {
                    this.attrs = [];
                    this.chooseTime = "";
                    this.chooseTime1 = "";
                }
            } else {
                if (this.attrs.length > 0) {
                    this.attrs = [];
                }
            }
            // 可用不足的高亮
            let insufficAvailability = {
                highlight: "orange",
                contentStyle: {
                    color: "white",
                },
                isDisabled: true,
                dates: this.insufficAvaliabeRedDate,
            };
            let datejson = {
                highlight: {
                    style: {
                        backgroundColor: "#2d8cf0",
                    },
                    contentStyle: {
                        color: "white",
                    },
                },
                dates: val.id,
            };
            this.attrs.push(datejson);
            if (this.insufficAvaliabeRedDate.length > 0) {
                this.attrs.push(insufficAvailability);
            }

            // if(insufficAvailability.dates.indexOf(val.id)>-1){
            //     this.$Message.error('可用不足的日期不能选择，请选择其他日期！');
            //     return;
            // }
            if (this.changeStatus == 1) {
                this.chooseTime = val.id;
            } else {
                let datearr = [];
                this.attrs.map((item) => {
                    if (item.highlight != "orange") {
                        datearr.push(item.dates);
                    }
                });
                // 进行日期排序
                let dateArr2 = this.compareFN2(datearr);
                // console.log(dateArr2,'dfsdsds')
                this.chooseTime = dateArr2[0];
                this.chooseTime1 = dateArr2[1];
            }
        },
        compareFN2(arr) {
            var i = 0;
            var j = 0;
            let t;
            for (i = 0; i < arr.length; i++) {
                for (j = 0; j < arr.length; j++) {
                    let oDate1 = new Date(arr[i]);
                    let oDate2 = new Date(arr[j]);
                    if (oDate1.getTime() < oDate2.getTime()) {
                        t = arr[i];
                        arr[i] = arr[j];
                        arr[j] = t;
                    }
                }
            }
            return arr;
        },
        // 切换左右两边的日子
        chooseOneDay() {
            let calendardates = this.$refs.reservatecalendar;
            // 重新渲染页面内容
            let date = calendardates.pages[0].key.split("-");
            if (date[1] < 10) {
                this.dayone = date[0] + "-0" + date[1] + "-01";
            } else {
                this.dayone = date[0] + "-" + date[1] + "-01";
            }
            this.getAllDateDrawing();
        },
        handleBtn(val) {
            this.changeStatus = val;
            this.chooseTime = "";
            this.chooseTime1 = "";
            this.attrs = [];
            this.disRange = [];
            this.insufficAvaliabeRedDate = [];
            this.getAllDateDrawing();
        },
        submit() {
            // 传递给上一层
            // if(!this.chooseTime1&&this.changeStatus==0){
            //     this.$Message.error('请选择备选日期！');
            //     return;
            // }
            let dataJson = {
                bookingType: this.changeStatus,
                clientRequestDate: this.chooseTime,
                secondClientRequestDate: this.chooseTime1,
            };
            this.$emit("on-update", dataJson);
            this.cancel();
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
